import styled from "styled-components";
import AntButton from "antd/es/button";
import { disabledStyle } from "common/Buttons/styles";
import { hexToRGB } from "@shared/utils/misc";
import { BOTTOM_NAVIGATOR } from "common/constants";

const LinkButton = styled(AntButton)<{ $error?: boolean }>`
  color: ${(p) => p.color || p.theme.colors.primaryBlue} !important;
  &:hover {
    @media (min-width: ${BOTTOM_NAVIGATOR}) {
        color: ${(p) =>
          hexToRGB(p.color || p.theme.colors.primaryBlue, 0.8)}; !important;
    }
  }
  &:focus {
    color: ${(p) => p.color || p.theme.colors.primaryBlue};
  }
  .anticon svg {
    color: ${(p) => hexToRGB(p.color || p.theme.colors.primaryBlue, 0.8)};
  }
  ${(p) => p.$error && disabledStyle}

  &.ant-btn-link:not(:disabled):not(.ant-btn-disabled):hover {
    @media (min-width: ${BOTTOM_NAVIGATOR}) {
      color: ${(p) =>
        hexToRGB(p.color || p.theme.colors.primaryBlue, 0.8)} !important;
    }
  }
`;

export default LinkButton;
